"use client";

import { useState, useEffect, Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";

function LoginForm() {
  const router = useRouter();
  const sp = useSearchParams();
  const next = sp.get("next") || "/";
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const saved = (() => {
      try { return localStorage.getItem("ezsplit_saved_user") || ""; } catch { return ""; }
    })();
    if (saved) setUsername(saved);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        setError(data.message || "로그인 실패");
        return;
      }
      try { localStorage.setItem("ezsplit_saved_user", username); } catch {}
      router.replace(next);
    } catch {
      setError("네트워크 오류");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "#0b0b0d" }}>
      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4 rounded-lg p-6" style={{ background: "#ffffff" }}>
        <div>
          <h1 className="text-lg font-semibold text-neutral-900">EzSplit</h1>
          <p className="text-sm text-black/65 mt-1">로그인</p>
        </div>
        <div>
          <label className="text-xs text-black/70">아이디</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            className="mt-1 w-full bg-black/[0.06] border border-black/[0.12] rounded px-3 py-2 text-sm text-neutral-900 outline-none focus:border-blue-500/50"
          />
        </div>
        <div>
          <label className="text-xs text-black/70">비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            className="mt-1 w-full bg-black/[0.06] border border-black/[0.12] rounded px-3 py-2 text-sm text-neutral-900 outline-none focus:border-blue-500/50"
          />
        </div>
        {error && <div className="text-xs text-loss">{error}</div>}
        <button
          type="submit"
          disabled={loading}
          className="w-full py-2 rounded bg-blue-600 text-neutral-900 text-sm font-medium hover:bg-blue-500 transition-colors disabled:opacity-50"
        >
          {loading ? "로그인 중..." : "로그인"}
        </button>
        <p className="text-2xs text-black/45">세션은 24시간 유지됩니다.</p>
      </form>
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={<div className="min-h-screen" />}>
      <LoginForm />
    </Suspense>
  );
}
